import { DownloadIcon, Paperclip } from 'lucide-react';
import {
  CloseIcon,
  LoadingIndicatorIcon,
  RetryIcon,
  UnsupportedAttachmentPreviewProps,
  useTranslationContext,
} from 'stream-chat-react';
import { AnyLocalAttachment, isLocalUploadAttachment } from '../stream-attachment-types';

export const UnsupportedAttachmentPreview = ({
  attachment,
  handleRetry,
  removeAttachments,
}: UnsupportedAttachmentPreviewProps) => {
  const { t } = useTranslationContext('UnsupportedAttachmentPreview');
  const title = attachment.title ?? t('Unsupported attachment');
  return (
    <div
      className="str-chat__attachment-preview-unsupported"
      data-testid="attachment-preview-unknown"
    >
      <div className="str-chat__attachment-preview-file-icon h-4 w-4">
        <Paperclip className="h-4 w-4" />
      </div>

      <button
        aria-label={t('aria/Remove attachment')}
        className="str-chat__attachment-preview-delete"
        data-testid="file-preview-item-delete-button"
        disabled={attachment.localMetadata?.uploadState === 'uploading'}
        onClick={() =>
          attachment.localMetadata?.id && removeAttachments([attachment.localMetadata?.id])
        }
      >
        <CloseIcon />
      </button>

      {isLocalUploadAttachment(
        attachment as unknown as AnyLocalAttachment<Record<string, unknown>>
      ) &&
        ['blocked', 'failed'].includes(attachment.localMetadata?.uploadState) &&
        !!handleRetry && (
          <button
            className="str-chat__attachment-preview-error str-chat__attachment-preview-error-file"
            data-testid="file-preview-item-retry-button"
            // @ts-expect-error - TODO: fix this
            onClick={() => handleRetry(attachment)}
          >
            <RetryIcon />
          </button>
        )}

      <div className="str-chat__attachment-preview-metadata">
        <div className="str-chat__attachment-preview-title" title={title}>
          {title}
        </div>
        {attachment.localMetadata?.uploadState === 'finished' && !!attachment.asset_url && (
          <a
            className="str-chat__attachment-preview-file-download"
            download
            href={attachment.asset_url}
            rel="noreferrer"
            target="_blank"
          >
            <DownloadIcon />
          </a>
        )}
        {attachment.localMetadata?.uploadState === 'uploading' && (
          <LoadingIndicatorIcon size={17} />
        )}
      </div>
    </div>
  );
};
